var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 43 44",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2281 0.772461C9.52291 0.772461 0 10.2954 0 22.0005C0 33.7057 9.52291 43.2286 21.2281 43.2286C32.9332 43.2286 42.4561 33.7057 42.4561 22.0005C42.4561 10.2954 32.9332 0.772461 21.2281 0.772461ZM29.7193 30.4918C28.8904 31.3206 27.5465 31.3206 26.7176 30.4918L21.7745 25.5486C20.0654 23.8395 19.1053 21.5215 19.1053 19.1046V11.3865C19.1053 10.2141 20.0557 9.26369 21.2281 9.26369C22.4005 9.26369 23.3509 10.2141 23.3509 11.3865V17.8621C23.3509 19.9492 24.18 21.9508 25.6557 23.4265L29.7193 27.4901C30.5482 28.319 30.5482 29.6629 29.7193 30.4918Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7193 30.4918C28.8904 31.3206 27.5465 31.3206 26.7176 30.4918L21.7745 25.5486C20.0654 23.8395 19.1053 21.5215 19.1053 19.1046V11.3865C19.1053 10.2141 20.0557 9.26369 21.2281 9.26369C22.4005 9.26369 23.3509 10.2141 23.3509 11.3865V17.8621C23.3509 19.9492 24.18 21.9508 25.6557 23.4265L29.7193 27.4901C30.5482 28.319 30.5482 29.6629 29.7193 30.4918Z",
    fill: "#EEEEEE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.429315a74085a60a141a31e98d0b814e.svg";
export { ForwardRef as ReactComponent };